import { Container, Link, Stack, Text } from "basis";
import { CreditCard } from "../CreditCard/CreditCard";
import { SvgInline } from "../SvgInline/SvgInline";

export const DirectDebitCancelSuccess = ({ state }) => (
  <Stack gap="8">
    <Container bg="grey.t05" padding="4">
      <CreditCard
        cardName={state.toAccount.data.cardName}
        cardEndsWith={state.toAccount.data.cardEndsWith}
      />
    </Container>
    <SvgInline name="direct-debit-payment-cancel" size="92" />
    <Text textStyle="heading5" textStyle-sm="heading4">
      Your direct debit has been cancelled
    </Text>
    <Text>
      You may set up a new direct debit request at any time via the Latitude
      Service Centre or Latitude App.
    </Text>
    <Link appearance="primary-button" width="256" href="/" newTab={false}>
      Go to overview
    </Link>
  </Stack>
);
